module.exports = __webpack_public_path__ + "img/btn_menu_all.5a128bf3.png";